import { Dayjs } from 'dayjs'
import { immer } from 'zustand/middleware/immer'

import { getToday } from '~/astra'

import { Department, PractitionerStatusDefinition, Speciality } from '../selectors'
import { Slice } from '../store'

export type DepartmentKey = Department['id'] | 'all'
export type SelectedSpecialties = Speciality['uuid'][] | 'all'
export type StatusCode = PractitionerStatusDefinition['code']

type State = {
    departmentKey: DepartmentKey
    selectedSpecialties: SelectedSpecialties
    selectedDate: Dayjs
}

type Actions = {
    actions: {
        setDepartment: (department: DepartmentKey) => void
        setSelectedDate: (date: Dayjs) => void
        setSelectedSpecialties: (specialties: SelectedSpecialties) => void
    }
}

export type FilterSlice = {
    appFilters: State & Actions
}

const initialState: State = {
    departmentKey: 'all',
    selectedSpecialties: 'all',
    selectedDate: getToday(),
}

export const createFilterSlice: Slice<FilterSlice> = immer(set => ({
    appFilters: {
        ...initialState,
        actions: {
            setSelectedDate: date =>
                set(state => {
                    state.appFilters.selectedDate = date
                }),
            setSelectedSpecialties: specialties =>
                set(state => {
                    state.appFilters.selectedSpecialties = specialties
                }),
            setDepartment: department =>
                set(state => {
                    state.appFilters.departmentKey = department
                }),
        },
    },
}))
